export default "__VITE_ASSET__COSMQO4N__"